import React from "react";
import {Link} from "react-router-dom";
import {Money} from "@/component/style/Money";
import {NumberTable} from "@/component/style/NumberTable";

export function ExternalAccountTable(props: any) {
    return (
        <NumberTable>
            <thead>
            <tr>
                <th>계정</th>
                <th align="right">증감</th>
            </tr>
            </thead>
            <tbody>{props.children}</tbody>
        </NumberTable>
    );
}

export function ExternalAccountTableRow(props: {
    name: string;
    amount: number;
    href?: string;
    className?: string
}) {
    return (
        <tr className={props.className}>
            <td>
                {props.href ? (
                    <Link to={props.href} color="inherit">{props.name}</Link>
                ) : (
                    props.name
                )}
            </td>
            <td align="right">
                <Money amount={props.amount}/>
            </td>
        </tr>
    );
}
